export default __webpack_public_path__ + "static/media/DSC_8756.b5b63a01.jpg";